import React from 'react'

type ListPageDescriptionProps = {
  value?: string | null
  /** Max lines shown in the table (default 2) */
  lines?: 2 | 3
  className?: string
  /**
   * muted — description / secondary text (default)
   * primary — label / name columns
   * sub — secondary line under a label (family title, etc.)
   */
  tone?: 'muted' | 'primary' | 'sub'
}

/**
 * Table text preview: 2-line clamp + native tooltip with full text.
 * Use for Description, Label/Name, and any other column that can wrap past 2 lines.
 */
export function ListPageDescription({
  value,
  lines = 2,
  className = '',
  tone = 'muted',
}: ListPageDescriptionProps) {
  const text = (value ?? '').trim()
  const toneClass =
    tone === 'primary'
      ? 'incyia-desc--primary'
      : tone === 'sub'
        ? 'incyia-desc--sub'
        : ''

  if (!text) {
    return (
      <span
        className={`incyia-desc is-empty ${toneClass} ${className}`.trim()}
      >
        —
      </span>
    )
  }

  return (
    <span
      className={`incyia-desc ${toneClass} ${className}`.trim()}
      title={text}
      data-lines={lines}
    >
      {text}
    </span>
  )
}

export default ListPageDescription
